import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useNavigate } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
  Button, Spinner,
} from 'react-bootstrap';
import { FaFile } from 'react-icons/fa';
import NumberFormat from 'react-number-format';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../../hooks/useAuth';
import { pageButtonRenderer, customTotal } from '../../common/constants';
import UserCard from '../../components/userCard';
import axiosCore from '../../common/axiosCore';

function Contribution() {
  const title = 'Contribution';
  const { getSession } = useAuth();
  const [contributionId, setContributionId] = useState();
  const navigate = useNavigate();
  const user = getSession();
  const [show, setShow] = useState(false);
  const [showContribution, setShowContribution] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState('');
  const [data, setData] = useState([]);
  const [OffId, setOffId] = useState();
  const [bft, setBft] = useState([]);
  const [offices, setOffices] = useState([]);
  const [contributionsList, setContributionsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const [isValid, setIsValid] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const { getMemberProfile } = useAuth();
  const member = getMemberProfile();

  const contributions = () => {
    setTimeout(() => {
      axiosCore.post('/member-module/contribution/new-contribution-list', {
        MemberId: member.MemberId,
      }).then((result) => {
        if (result.data.status === 1) {
          setIsWaiting(false);
          setContributionsList(result.data.data);
        }
      }).catch(() => {
        setIsError(true);
      });
    }, 2000);
  };

  useEffect(() => {
    contributions();
    const interval = setInterval(() => {
      contributions();
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setShow(false);
    setShowContribution(false);
  };

  // const handleShow = () => setShow(true);

  const getActionFormat = (cell, row) => (
    <div>
      <Button className="btn btn-green btn-sm" onClick={() => {
        setData(row);
        setModalTitle('Contribution Status');
        setShowContribution(true);
      }} >
        View
      </Button>
    </div>);

  const getContributionPeriod = (cell, row) => (
    <div>
      {row.MONTH} {row.YEAR}
    </div>
  );

  const getAmount = (cell, row) => (
    <NumberFormat value={row.AMOUNT} displayType={'text'} thousandSeparator={true} prefix={'TZS '} />
  );

  const columns = [{
    dataField: 'MONTH',
    text: 'Period',
    isDummyField: true,
    formatter: getContributionPeriod,
    headerStyle: (column, colIndex) => ({
      width: '80px',
    }),
  },
  {
    dataField: 'RECEIPT_DATE',
    text: 'Receipt Date',
    headerStyle: (column, colIndex) => ({
      width: '120px',
    }),
  },
  {
    dataField: 'RECEIPT_NO',
    text: 'Receipt #',
    width: '100px',
    headerStyle: (column, colIndex) => ({
      width: '110px',
    }),
  },
  {
    dataField: 'EMPNAME',
    text: 'Employer Name',
  },
  {
    dataField: 'AMOUNT',
    text: 'Amount',
    formatter: getAmount,
    headerStyle: (column, colIndex) => ({
      width: '140px',
    }),
  },
  ];

  const contributionListData = () => {
    if (contributionsList.length > 0) {
      return <span>
        <div className="table-responsive">
        <BootstrapTable
          bootstrap4
          keyField='RECEIPT_NO'
          data={ contributionsList }
          columns={ columns }
          pagination={ paginationFactory(options) }
          striped
          hover
          condensed
        />
      </div>
      </span>;
    }
    return <span>
      {!isWaiting && <p className="text-center">No Contributions</p>}
    </span>;
  };

  const handleSelectOffice = (e) => {
    setOffId(e.value);
  };

  const handleSelectBenefit = (e) => {
    setContributionId(e.value);
  };

  const options = {
    pageButtonRenderer,
    paginationSize: 4,
    pageStartIndex: 0,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: 'Back',
    nextPageText: 'Next',
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: '5', value: 5,
    }, {
      text: '10', value: 10,
    }, {
      text: 'All', value: contributionsList.length,
    }], // A numeric array is also available. the purpose of above example is custom the text
  };

  const onConfirm = () => {
    setIsAlert(false);
    setIsPending(false);
    setIsError(false);
    setIsWaiting(false);
  };

  if (user) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <main className="container">
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/console/dashboard">Dashboard</Link></Breadcrumb.Item>
            <Breadcrumb.Item active>{title}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="row">
            <div className="col">
              <h1 className="page-title">{title}</h1>
            </div>
            <div className="col">
               <Link type="button" className="btn btn-claim mb-3" to="/console/statement">
                 <FaFile/> View Statement
               </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 rounded">
              <UserCard/>
            </div>
            <div className="col-lg-8 rounded">
              <div className="card">
                <h6 className="card-header d-flex justify-content-between align-items-center">
                  Contributions List
                </h6>
                <div className="card-body m-0" id='contribution-list'>
                  {isWaiting && <p className="text-center">
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      hidden={!isWaiting}/> Please wait...</p>}
                  <div className="table-responsive">
                    {contributionListData()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        {isAlert
        && <SweetAlert
          success
          title="Success Data!"
          onConfirm={onConfirm}
          timeout={2000}
        >
          This success message will automatically close after 2 seconds
        </SweetAlert>
        }
        {isError
        && <SweetAlert
          warning
          title="Oops, an error occurred."
          onConfirm={onConfirm}
          timeout={10000}
        >
          Check your connection and try again
        </SweetAlert>}
        {isPending
        && <SweetAlert
          warning
          title="Oops, you have a pending claim."
          onConfirm={onConfirm}
          timeout={50000}
        >
          Please wait for your previous claim to be processed
        </SweetAlert>}
      </>
    );
  }
  navigate('/login');
}
export default Contribution;
